export const brandColor = "#F84123"; // "#f4553b"; // "#f46a54"; //  "#E94A24";
export const buttonGray = "#F2F2F2";
export const buttonGrayLight = "#aeaeb2";
export const buttonGrayText = "#8B8B8D";

//title: avenir 85 heavy  // "Avenir Heavy"  Regular: Avenir
//font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu;

// const defaultFont =
//   Platform.OS === "ios"
//     ? "System"
//     : IsAppleUniverse
//     ? "-apple-system, BlinkMacSystemFont"
//     : "Nunito_regular";
// const defaultTitleFont =
//   Platform.OS === "ios"
//     ? "System"
//     : IsAppleUniverse
//     ? "-apple-system, BlinkMacSystemFont"
//     : "Nunito_bold";
